import { type Draft } from 'immer'
import { matchesRef } from '../../../schema/validation/resourceObject'
import {
  type BoardObjectsTransform,
  type IncludedOfType,
  type IncludedRef,
} from './types'

type MomentResource = IncludedOfType<'moment'>
type MomentRelationships = MomentResource['relationships']
type RelationshipValue<TName extends keyof MomentRelationships> =
  MomentRelationships[TName]

export const setMomentRelationship =
  <TName extends keyof MomentRelationships>(
    momentRef: IncludedRef<'moment'>,
    name: TName,
    valueOrUpdater:
      | RelationshipValue<TName>
      | undefined
      | ((
          current: RelationshipValue<TName> | undefined
        ) => RelationshipValue<TName> | undefined)
  ): BoardObjectsTransform =>
  (draft) => {
    const moment = draft.included?.find(matchesRef(momentRef))
    if (!moment) return draft

    const current = moment.relationships[name] as
      | RelationshipValue<TName>
      | undefined
    const next =
      typeof valueOrUpdater === 'function'
        ? valueOrUpdater(current)
        : valueOrUpdater

    moment.relationships[name] = next as Draft<MomentRelationships>[TName]
    return draft
  }
